<template>
  <div class="comparablelist-template">
    <div v-if="loadingComps" class="brains-map-loader dataSidebarLoader" />
    <div class="comparables_title">
      <div class="comparables_title--text">
        {{ $t('showing') }} <strong>{{ currentComparables.length }}</strong> {{ $t('data-points-lower') }}
      </div>
      <div class="comparables-input-buttons-container">
        <div class="comparables_title--input-search">
          <div class="input-search">
            <textInput v-model="searchComp" :placeholder="$t('search-pois')" icon="search" class="brains-type1-number-input" />
          </div>
        </div>
        <div class="comparables_buttons">
          <popoverBtn class="brains-dropdown-list" :button="false" activator="click" position="left" :border="true">
            <template v-slot:popoverName>
              <button type="button" class="comparable_btn comparable_btn--menu brains-icon-btn-type-1" title="Open options"><font-awesome-icon icon="bars" /></button></template>
            <div v-loading="loadingComps" class="container-popover-selector">
              <div class="brains-dropdown-list-comparables">
                <div class="brains-dropdown-list-comparables--item">
                  <popoverBtn :button="false" activator="click" position="bottom-left" :border="true">
                    <template
                      v-slot:popoverName
                    ><button slot="reference" type="button" class="comparable_btn btn-list-dropdown" title="Info">
                      <font-awesome-icon icon="info" /> <span>{{ $t('information') }}</span>
                    </button></template>
                    <div class="container-popover-selector legend_comp_container">
                      <div>
                        <div class="legend_comp_pub_sel" />
                        {{ $t("valuationFilters.published") }} &#38; {{ $t("assetData.selected") }}
                      </div>
                      <div>
                        <div class="legend_comp_unpub_sel" />
                        {{ $t("valuationFilters.unpublished") }} &#38; {{ $t("assetData.selected") }}
                      </div>
                      <div>
                        <div class="legend_comp_pub" />
                        {{ $t("valuationFilters.published") }}
                      </div>
                      <div>
                        <div class="legend_comp_unpub" />
                        {{ $t("valuationFilters.unpublished") }}
                      </div>
                    </div>
                  </popoverBtn>
                </div>
                <div class="brains-dropdown-list-comparables--item">
                  <button type="button" class="comparable_btn btn-list-dropdown" :title="$t('userData.download-excel')" @click="donwloadCurrentComparables">
                    <font-awesome-icon icon="download" /> <span>{{ $t('userData.download-excel') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </popoverBtn>

          <button type="button" class="comparable_btn comparable_btn--menu brains-icon-btn-type-1" title="All/Only Selected" @click="showAll">
            <font-awesome-icon v-if="showall" icon="toggle-off" />
            <font-awesome-icon v-else icon="toggle-on" />
          </button>
        </div>
      </div>
    </div>

    <div class="comparablelist">
      <table class="comparables_table" aria-describedby="comps">
        <thead>
          <tr>
            <th @click="filterTableBy('c_ID_tipo')">
              {{ $t("type") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_ID_tipo' && filteredby !== 'c_ID_tipo_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_ID_tipo'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_ID_tipo_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th @click="filterTableBy('c_dist')">
              {{ $t("valuationFilters.dist") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_dist' && filteredby !== 'c_dist_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_dist'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_dist_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th @click="filterTableBy('c_direccion_completa')">
              {{ $t("assetData.address") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_direccion_completa' && filteredby !== 'c_direccion_completa_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_direccion_completa'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_direccion_completa_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th @click="filterTableBy('c_superficie')">
              {{ $t("valuationFilters.sqm") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_superficie' && filteredby !== 'c_superficie_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_superficie'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_superficie_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th @click="filterTableBy('c_precio')">
              {{ $t("price") }} (€)
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_precio' && filteredby !== 'c_precio_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_precio'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_precio_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th @click="filterTableBy('c_eurom2')">
              {{ $t("marketplace.eur-sqm") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'c_eurom2' && filteredby !== 'c_eurom2_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'c_eurom2'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'c_eurom2_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
            <th class="cursor-default">Evo.</th>
            <th @click="filterTableBy('c_habitaciones')">
              <div class="svg-icon-comps">
                <img width="15px" :src="bedicon" alt="image">
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="filteredby !== 'c_habitaciones' && filteredby !== 'c_habitaciones_desc'" icon="sort" />
                  <font-awesome-icon v-if="filteredby === 'c_habitaciones'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="filteredby === 'c_habitaciones_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </div>
            </th>
            <th @click="filterTableBy('pubdays')">
              {{ $t("valuationFilters.on-brains") }}
              <span class="filter-icon-comps">
                <font-awesome-icon v-if="filteredby !== 'pubdays' && filteredby !== 'pubdays_desc'" icon="sort" />
                <font-awesome-icon v-if="filteredby === 'pubdays'" class="filter-icon-comps--selected" icon="sort-up" />
                <font-awesome-icon v-if="filteredby === 'pubdays_desc'" class="filter-icon-comps--selected" icon="sort-down" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody id="selectedcomparables_table">
          <tr
            v-for="comparable in filteredSelectedComparables"
            :id="'comparable-' + comparable.iD_comparable"
            :key="comparable.iD_comparable + '_selected'"
            class="selectedrow"
            :class="getComparablesClass(true, comparable)"
            @click="removeComparable(comparable.iD_comparable)"
            @mouseenter="showComparableInMap(comparable)"
            @mouseleave="hideComparableInMap(comparable)"
          >
            <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="image"></td>
            <td>{{ formatterDist(comparable.c_dist) }}</td>
            <td class="comparables_adress">
              <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </a>
              <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
              <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
              <span v-else>na</span>
            </td>
            <td>{{ formatterSqm(comparable.c_superficie) }}</td>
            <td>{{ formatterPrice(comparable.c_precio) }}</td>
            <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
            <td>
              <popoverBtn :button="false" activator="mouseover" position="left">
                <template v-slot:popoverName>
                  <span class="comparable-icon-history" @mouseenter="showComparableHistory(comparable)">
                    <span v-if="comparable.c_inc_precio12 < 0"><font-awesome-icon icon="arrow-down" /></span>
                    <span v-else-if="comparable.c_inc_precio12 > 0"><font-awesome-icon icon="arrow-up" /></span>
                    <span v-else><font-awesome-icon icon="equals" /></span>
                  </span>
                </template>
                <div :id="'tt_history_' + comparable.iD_comparable" class="tooltip_history_comp" />
              </popoverBtn>
            </td>
            <td>{{ comparable.c_habitaciones }}</td>
            <td>{{ formatterTime(comparable.pubdays) }}</td>
          </tr>
        </tbody>
        <tbody id="comparableslist_table">
          <tr
            v-for="comparable in filteredComparableslist"
            :id="'comparable-' + comparable.iD_comparable"
            :key="comparable.iD_comparable"
            :class="getComparablesClass(false, comparable)"
            @click="addComparable(comparable.iD_comparable)"
            @mouseenter="showComparableInMap(comparable)"
            @mouseleave="hideComparableInMap(comparable)"
          >
            <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="image"></td>
            <td>{{ formatterDist(comparable.c_dist) }}</td>
            <td class="comparables_adress">
              <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </a>
              <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
              <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
              <span v-else>na</span>
            </td>
            <td>{{ formatterSqm(comparable.c_superficie) }}</td>
            <td>{{ formatterPrice(comparable.c_precio) }}</td>
            <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
            <td>
              <popoverBtn :button="false" activator="mouseover" position="left">
                <template v-slot:popoverName>
                  <span class="comparable-icon-history" @mouseenter="showComparableHistory(comparable)">
                    <span v-if="comparable.c_inc_precio12 < 0"><font-awesome-icon icon="arrow-down" /></span>
                    <span v-else-if="comparable.c_inc_precio12 > 0"><font-awesome-icon icon="arrow-up" /></span>
                    <span v-else><font-awesome-icon icon="equals" /></span>
                  </span>
                </template>
                <div :id="'tt_history_' + comparable.iD_comparable" class="tooltip_history_comp" />
              </popoverBtn>
            </td>
            <td>{{ comparable.c_habitaciones }}</td>
            <td>{{ formatterTime(comparable.pubdays) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import textInput from '@/components/designComponents/textInput'
import popoverBtn from '@/components/designComponents/popoverBtn'
import numeral from 'numeral'
import { _ } from 'vue-underscore'
import bedicon from '@/assets/brains_icons/bedon.svg'
export default {
  name: 'CompsList',
  components: { popoverBtn, textInput },
  data() {
    return {
      bedicon: bedicon,
      comparableslist: [],
      selectedcomparables: [],
      searchComp: '',
      showall: true,
      filteredby: 'c_dist',
      isfirst: true,
      loading: false,
      showInfoContent: false,
      loadingComps: false
    }
  },
  computed: {
    ...mapState('valuations', {
      currentComparables: (state) => state.currentComparables,
      currentFilter: (state) => state.currentFilter,
      filteringByGeolevel: (state) => state.currentFilter
    }),
    filteredSelectedComparables: function() {
      if (this.searchComp !== '') {
        return this.selectedcomparables.filter((item) => {
          return item.c_direccion_completa.toLowerCase().includes(this.searchComp.toLowerCase())
        })
      } else {
        return this.selectedcomparables
      }
    },
    filteredComparableslist: function() {
      if (this.searchComp !== '') {
        return this.comparableslist.filter((item) => {
          return item.c_direccion_completa.toLowerCase().includes(this.searchComp.toLowerCase())
        })
      } else {
        return this.comparableslist
      }
    }
  },
  watch: {
    currentComparables: function(newOne) {
      // debugger
      this.comparableslist = []
      // Se comprueba que el filtro que ha cambiado es de localizacion y no otro, si no es de localizacion,
      // los comparables actuales seleccionados por el usuario no se actualizan
      if (this.filteringByGeolevel) {
        this.selectedcomparables = []
        this.selectedcomparables = _.filter(this.currentComparables, function(item) {
          return item.c_categoria === 'Publicados'
        }).slice(0, 5)

        var comparablesunpub = _.filter(this.currentComparables, function(item) {
          return item.c_categoria === 'No publicados'
        }).slice(0, 5)

        comparablesunpub.forEach((element) => {
          this.selectedcomparables.push(element)
        })

        this.selectedcomparables = _.sortBy(this.selectedcomparables, function(item) {
          return item.c_dist
        })
      }

      this.currentComparables.map((item, i) => {
        if (!this.selectedcomparables.includes(item)) {
          this.comparableslist.push(item)
        }
      })

      this.UpdateSelectedComparables()
    }
  },
  created() {
    this.$root.$on('ComparableClicked', (idcomparable) => {
      this.MapClickedComparable(idcomparable)
    })

    this.$root.$on('comparableValuationHoveredOut', () => {
      this.removeOldHovered()
    })

    this.$root.$on('comparableValuationHovered', (idcomparable) => {
      this.MapHoveredComparable(idcomparable)
    })
  },
  methods: {
    UpdateSelectedComparables() {
      const vm = this
      vm.$store.dispatch('valuations/setselectedcomparables', vm.selectedcomparables)
    },
    MapClickedComparable(idcomp) {
      var vm = this
      var asset = _.filter(vm.selectedcomparables, function(item) {
        return item.iD_comparable === idcomp
      })[0]
      if (asset !== undefined) {
        vm.removeComparable(idcomp)
      } else {
        vm.addComparable(idcomp)
      }
    },
    addComparable(idcomp) {
      var vm = this
      var asset = _.filter(vm.comparableslist, function(item) {
        return item.iD_comparable === idcomp
      })[0]
      if (asset !== undefined) {
        vm.selectedcomparables.push(asset)
        vm.comparableslist = _.reject(vm.comparableslist, function(item) {
          return item.iD_comparable === idcomp
        })
        if (this.filteredby.includes('_desc')) {
          var sortby = this.filteredby.replace('_desc', '')
          vm.selectedcomparables = _.sortBy(this.selectedcomparables, sortby).reverse()
        } else {
          vm.selectedcomparables = _.sortBy(this.selectedcomparables, this.filteredby)
        }
        /*
        this.valuationSave.comparables.selected = this.selectedcomparables
        this.valuationSave.comparables.deselected = this.comparableslist
        */
        // this.$root.$emit('UpdateSelectedComparables__' + this.namespaceKey)
        vm.UpdateSelectedComparables()
      }
    },
    removeComparable(idcomp) {
      var vm = this
      var asset = _.filter(vm.selectedcomparables, function(item) {
        return item.iD_comparable === idcomp
      })[0]
      if (asset !== undefined) {
        vm.comparableslist.push(asset)
        vm.selectedcomparables = _.reject(vm.selectedcomparables, function(item) {
          return item.iD_comparable === idcomp
        })
        if (this.filteredby.includes('_desc')) {
          var sortby = this.filteredby.replace('_desc', '')
          vm.comparableslist = _.sortBy(this.comparableslist, sortby).reverse()
          vm.selectedcomparables = _.sortBy(this.selectedcomparables, sortby).reverse()
        } else {
          vm.comparableslist = _.sortBy(this.comparableslist, this.filteredby)
          vm.selectedcomparables = _.sortBy(this.selectedcomparables, this.filteredby)
        }
        /*
        this.valuationSave.comparables.selected = this.selectedcomparables
        this.valuationSave.comparables.deselected = this.comparableslist
        */
        // this.$root.$emit('UpdateSelectedComparables__' + this.namespaceKey)
        vm.UpdateSelectedComparables()
      }
    },
    showComparableInMap(comparable) {
      this.$root.$emit('ShowComparableInMap', {
        geometry:
          { longitude: comparable.c_longitud, latitude: comparable.c_latitud },
        attributes:
          { iD_comparable: comparable.iD_comparable }
      }, true)
    },
    hideComparableInMap(comparable) {
      this.$root.$emit('ShowComparableInMap', {
        geometry:
          { longitude: comparable.c_longitud, latitude: comparable.c_latitud },
        attributes:
          { iD_comparable: comparable.iD_comparable }
      }, false)
    },
    removeOldHovered() {
      var old_hovered = document.getElementsByClassName('comparable-hovered-map')
      if (old_hovered !== undefined && old_hovered !== null && old_hovered.length > 0) {
        old_hovered[0].classList.remove('comparable-hovered-map')
      }
    },
    MapHoveredComparable(idcomparable) {
      var comparable_tr = document.getElementById('comparable-' + idcomparable)
      comparable_tr.classList.add('comparable-hovered-map')
      comparable_tr.scrollIntoView({ block: 'end' })
      // document.getElementsByClassName('comparables_table')[0].scrollBy(0, 500)
    },
    getHeadersByLang() {
      return [
        this.$t('id-comparable'),
        this.$t('contract-type'),
        this.$t('portfolio'),
        this.$t('listing-date'),
        this.$t('removal-date'),
        this.$t('typology'),
        this.$t('assetData.subtype'),
        this.$t('product-type'),
        this.$t('address'),
        this.$t('marketplace.eur-sqm'),
        this.$t('floor'),
        this.$t('valuationFilters.elevator'),
        this.$t('nrooms'),
        this.$t('marketplace.baths'),
        this.$t('parking'),
        this.$t('maps.pool'),
        this.$t('storage'),
        this.$t('valuationFilters.sqm'),
        this.$t('price'),
        this.$t('rent-price'),
        this.$t('district'),
        this.$t('district') + ' 2',
        this.$t('link'),
        this.$t('locationSelector.latitude'),
        this.$t('locationSelector.longitude'),
        this.$t('approximate-position'),
        this.$t('category'),
        this.$t('telephone'),
        this.$t('image') + ' 1',
        this.$t('image') + ' 2',
        this.$t('image') + ' 3',
        this.$t('image') + ' 4',
        this.$t('image') + ' 5',
        this.$t('image') + ' 6',
        this.$t('image') + ' 7',
        this.$t('image') + ' 8',
        this.$t('image') + ' 9',
        this.$t('image') + ' 10',
        this.$t('description'),
        this.$t('built-year'),
        this.$t('annual-price-change'),
        this.$t('assetData.selected'),
        this.$t('valuationFilters.distance') + ' (m)',
        this.$t('days-published')
      ]
    },
    donwloadCurrentComparables() {
      this.loadingComps = true
      const vm = this
      var headers = this.getHeadersByLang()

      vm.$store.dispatch('valuations/downloadcomps', { query: vm.currentFilter, headers: headers, currentComparables: this.filteredSelectedComparables }).then((response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'CurrentComparables.xlsx'
        link.click()
        this.loadingComps = false
      }).catch(e => {
        console.log(e)
        this.loadingComps = false
      })
    },
    showComparableHistory(comparable) {
      var vm = this
      vm.$store.dispatch('valuations/searchcomphistory', { ID_comparable: comparable.iD_comparable, c_tipocontrato: comparable.c_tipocontrato }).then((response) => {
        var tooltip = '<div class="tt_history_title"><div>'
        if (comparable.c_inc_precio12 === 0 || comparable.c_inc_precio12 === null) {
          tooltip += 'Pricing history'
        } else {
          tooltip += comparable.c_inc_precio12.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '%'
        }
        tooltip += '</div></div><table class="mt-1 mb-1">'
        _.forEach(response, function(item, i) {
          tooltip +=
            '<tr><td style="padding: 3px;">' +
            vm.$moment(item.date).format('DD/MM/YYYY') +
            '</td><td style="padding: 3px;">' +
            item.price.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
            '€</td><td style="padding: 3px;">' +
            (item.typo === 'oferta' ? 'Offer' : item.typo === 'publicado' ? (i === 0 ? 'First Published' : 'Price Change') : 'Transaction') +
            '</td></tr>'
        })
        if (comparable.c_fechabaja !== null) {
          tooltip +=
            '<tr><td style="padding: 3px;">' +
            vm.$moment(comparable.c_fechabaja).format('DD/MM/YYYY') +
            '</td><td style="padding: 3px;">' +
            comparable.c_precio.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
            '€</td><td>Unpublished</td></tr>'
        }
        tooltip += '</table'
        document.getElementById('tt_history_' + comparable.iD_comparable).innerHTML = tooltip
      })
    },
    getComparablesClass(selected, comparable) {
      if (selected) {
        return comparable.c_categoria === 'Publicados' ? 'comparable_pub_selected' : 'comparable_nopub_selected'
      }
      return comparable.c_categoria === 'Publicados' ? 'comparable_pub' : 'comparable_nopub'
    },
    formatterDate(itm) {
      return itm !== null ? this.$moment(itm).format('MM/YYYY') : ''
    },
    formatterPrice(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterEurSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterDist(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterTime(itm) {
      return itm !== null ? numeral(itm).format('0') + ' d' : ''
    },
    formatterTypology(idtipo) {
      switch (idtipo) {
        case 0:
          return require('@/assets/brains_icons/residential.png')
        case 1:
          return require('@/assets/brains_icons/flatblack.png')
        case 2:
          return require('@/assets/brains_icons/house.png')
        case 3:
          return require('@/assets/brains_icons/parking.png')
        case 4:
          return require('@/assets/brains_icons/storage.png')
        case 5:
          return require('@/assets/brains_icons/land.png')
        case 6:
          return require('@/assets/brains_icons/retail.png')
        case 7:
          return require('@/assets/brains_icons/office.png')
        case 8:
          return require('@/assets/brains_icons/building.png')
        case 9:
          return require('@/assets/brains_icons/hospitality.png')
        case 10:
          return require('@/assets/brains_icons/industrial.png')
        case 11:
          return require('@/assets/brains_icons/other.png')
        default:
          return require('@/assets/brains_icons/other.png')
      }
    },
    filterTableBy(by, order = '') {
      this.comparableslist = _.sortBy(this.comparableslist, by)
      this.selectedcomparables = _.sortBy(this.selectedcomparables, by)
      if (by === this.filteredby || order === 'desc') {
        this.comparableslist = this.comparableslist.reverse()
        this.selectedcomparables = this.selectedcomparables.reverse()
        this.filteredby = by + '_desc'
      } else if (order === '') {
        this.filteredby = by
      }
      this.sort_popup = false
      this.UpdateSelectedComparables()
    },
    showAll() {
      if (this.showall) {
        document.getElementById('comparableslist_table').style.display = 'none'
      } else {
        document.getElementById('comparableslist_table').style.display = 'table-row-group'
      }
      this.showall = !this.showall
    }
  }
}
</script>

<style lang="scss">
.comparablelist-template .caret-wrapper {
  display: none !important;
}
.tt_history_title {
  width: 100% !important;
  background-color: #1e3cff;
  margin-left: -10px;
  margin-right: -10px;
  margin-top: -10px;
  height: 20px;
  vertical-align: middle;
  font-weight: bold;
  font-size: 1.1em;

  & > div {
    margin-left: 10px;
    padding-top: 5px;
  }
}
</style>

<style lang="scss" scoped>
.brains-dropdown-list {
  .brains-popover-container {
    .container-popover-selector {
      overflow: visible !important;
    }
  }
}
.brains-dropdown-list-comparables {
  width: 235px;
  padding-top: 10px;
  // min-height: 125px;
  padding-bottom: 10px;

  &--item {
    margin-bottom: 5px;
  }
}

.btn-list-dropdown {
  color: #1e3cff;
  padding-left: 0;
  display: flex;
  justify-content: flex-start;

  &:hover {
    color: black;
  }

  svg {
    margin-right: 5px;
    width: 20px;
    // color: #1e3cff;
  }

  span {
    font-size: 16px;
  }
}

.comparablelist {
  height: calc(100vh - 190px);
  overflow: auto;
  width: 100%;
  overflow-x: hidden;
}

.comparablelist-template table {
  width: 100%;
  font-size: 12px !important;
  border-spacing: 0;

  thead {
    th {
      position: sticky;
      padding: 4px;
      top: 0;
      // color: #1e3cff;
      color: #333333;
      background-color: white;
      border-bottom: 2px solid #1e3cff;
      font-family: "Montserrat-SemiBold",sans-serif;
      font-size: 14px;
      z-index: 9;
    }

    &:hover {
      cursor: pointer;
    }

    th:nth-child(8) {
      padding: 0 !important;
    }

    th:nth-child(1),
    th:nth-child(2),
    th:nth-child(7),
    th:nth-child(8) {
      text-align: center;
    }

    th:nth-child(4),
    th:nth-child(5),
    th:nth-child(6) {
      text-align: right;
    }
  }

  tbody {
    tr {
      height: 22px;
    }
    td {
      height: 18px;
      border-bottom: none;
    }

    td:nth-child(7) {
      position: relative;
    }

    td:nth-child(1),
    td:nth-child(2),
    td:nth-child(7) {
      text-align: center;

      img {
        vertical-align: middle;
      }
    }

    td:nth-child(4),
    td:nth-child(5),
    td:nth-child(6) {
      text-align: right;
    }

    td:nth-child(8),
    td:nth-child(9) {
      text-align: center;
    }

    .comparable_pub_selected {
      background-color: rgb(216,175,70);

      &:hover {
        cursor: pointer;
        background-color: rgba(216,175,70, 0.596);
      }
    }
    .comparable_nopub_selected {
      background-color: rgb(194,194,194);
      &:hover {
        cursor: pointer;
        background-color: rgba(194,194,194, 0.425);
      }
    }
    .comparable_pub {
      background-color: rgb(232,210,128);
      &:hover {
        cursor: pointer;
        background-color: rgba(232,210,128, 0.548);
      }
    }
    .comparable_nopub {
      background-color: rgb(240,240,240);
      &:hover {
        cursor: pointer;
        background-color: rgba(240,240,240, 0.349);
      }
    }
  }

  .comparables_adress {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 130px;

    a {
      text-decoration: underline !important;
    }
  }
}

.legend_comp_container {
  font-size: 11px;
  width: 160px;

  & > div {
    display: flex;
    margin-bottom: 5px;
    gap: 5px;
  }

  .legend_comp_pub_sel {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    background-color: rgb(216,175,70);
    border: 1px solid black;
    margin-right: 5px;
  }
  .legend_comp_unpub_sel {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    background-color: rgb(136,136,136);
    border: 1px solid black;
    margin-right: 5px;
  }
  .legend_comp_pub {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    background-color: rgb(232,210,128);
    border: 1px solid black;
    margin-right: 5px;
  }
  .legend_comp_unpub {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    background-color: rgb(194,194,194);
    border: 1px solid black;
    margin-right: 5px;
  }
}

.orderbyselector div {
  cursor: pointer;
  padding: 3px;
  font-size: 12px;

  &:hover {
    background-color: #1e3cff;
    border-radius: 5px;
    color: white;
  }

  &.selected {
    background-color: lightblue;
  }
}

.comparablelist-template {
  height: 100%;
  font-family: "Montserrat-Regular",sans-serif;
}

.comparables_title {
  color: black;
  padding: 7px 10px;
  font-size: 16px;
  display: flex;
  height: 47px;
  align-items: center;
  justify-content: space-between;

  &--text {
    font-size: 14px;
    padding-left: 15px;

    strong {
      font-weight: 600;
    }
  }

  &--input-search {
    width: 100%;
    max-width: 350px;
    display: flex;
    justify-content: flex-end;
  }
}

.comparables_buttons {
  margin-right: 0;
  display: flex;

  .comparable_btn {
    background-color: transparent;
    cursor: pointer;
    border: none;
    outline: none;

    &--menu {
      font-size: 1.5em;
    }
  }
}

.smaller_text {
  font-size: 9px;
}

.tooltip_history_comp {
  width: 230px;
  color: black;
  font-size: 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.comparable-icon-history {
  padding-left: 5px;
}

.svg-icon-comps {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  fill: #333333;

  .svg-icon {
    width: 1.5em;
    height: 1em;
  }
}

.filter-icon-comps {
  &--selected {
    // color: #009999;
  }
}

.comparables-input-buttons-container {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  align-items: center;
}
</style>

<style lang="scss">
.printing-png-valuation {
  position: absolute !important;
  top: 0 !important;
  height: 100%;
  z-index: 100 !important;
  width: 100% !important;
}

.brains-comparables-filter-popover {
  .brains-popover-container {
    left: -155px;
  }
}

.comparable-hovered-map {
  background-color: rgb(43, 163, 158) !important;
  color: #333333;
  font-family: 'Montserrat-SemiBold',sans-serif;
}
</style>
